import React, { useState } from "react";
import { CONCEPTS, READ_SCENARIOS } from "./data.js";

export default function ReadStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [picked, setPicked] = useState(null);

  const current = READ_SCENARIOS[index];
  const done = index >= READ_SCENARIOS.length;

  const choose = (conceptId) => {
    if (picked) return;
    const correct = conceptId === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setPicked(conceptId);
  };

  const advance = () => {
    setPicked(null);
    setIndex((i) => i + 1);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-gold">Read Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Six Principles, Mapped</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Right Concept</span>
            <span className="text-gold">
              {correctCount}/{READ_SCENARIOS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          BATNA, walkaway power, interests over positions, loss aversion, tactical empathy,
          entropy — the tactics are just the surface. This is what's actually moving underneath
          them.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          SIT DOWN FOR THE STANDOFF ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>BETWEEN THE LINES</span>
        <span>
          {index}/{READ_SCENARIOS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">Which principle actually explains this moment?</p>

      <div
        key={current.id}
        className={`mb-5 border-2 bg-ink p-6 text-center transition-colors ${
          picked ? (picked === current.correct ? "border-lime shadow-glow-cyan" : "border-danger") : "border-black"
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      {!picked ? (
        <div className="space-y-2">
          {CONCEPTS.map((concept) => (
            <button
              key={concept.id}
              onClick={() => choose(concept.id)}
              className="flex w-full items-center justify-between border-2 border-mist/30 px-4 py-3 text-left transition-colors hover:border-gold hover:text-gold"
            >
              <span className="font-display text-[9px] uppercase">{concept.label}</span>
              <span className="text-[11px] text-mist/50">{concept.subtitle}</span>
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            picked === current.correct ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-1 font-display text-[9px] uppercase">
            {picked === current.correct
              ? "Right Concept"
              : `Not Quite — It Was ${CONCEPTS.find((c) => c.id === current.correct)?.label}`}
          </p>
          <p className="mb-3 text-xs text-mist/80">{current.explain}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
